module.exports = __webpack_public_path__ + "img/bear-face.cb5ceeab.png";